export var VIDEO_LIST_ITEM_WIDTH = 272;
export var VIDEO_LIST_ITEM_HEIGHT = 153;
